import numeral from 'numeral'

export function formatCurrency(price?: number, cents = false, currencyPrefix = '$') {
  if (price == null) {
    return ''
  }

  const format = cents ? '0,0.00' : '0,0'
  return `${currencyPrefix}${numeral(price).format(format)}`
}
